import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Song } from 'src/app/models/songModel';

@Component({
  selector: 'app-m-album-item',
  templateUrl: './m-album-item.component.html',
  styleUrls: ['./m-album-item.component.scss'],
})
export class MAlbumItemComponent implements OnInit {
  @Input() song: Song;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {}

  getCoverSrc(cover: string | undefined): SafeUrl | string {
    if (cover?.startsWith('data:')) {
      return this.sanitizer.bypassSecurityTrustUrl(cover);
    }
    return cover || 'assets/default_cover.jpeg';
  }
}
